export const USER_ACTIONS = {
  REQUEST: 'USER_REQUEST',
  SUCCESS: 'USER_SUCCESS',
  FAILURE: 'USER_FAILURE'
};

export function getUserRequest() {
  return {
    type: USER_ACTIONS.REQUEST
  };
}

export function getUserSuccess(payload) {
  return {
    payload,
    type: USER_ACTIONS.SUCCESS
  };
}

export function getUserFailure(error) {
  return {
    error,
    type: USER_ACTIONS.FAILURE
  };
}
